import { render, staticRenderFns } from "./BancoNormas.vue?vue&type=template&id=51f34840&"
import script from "./BancoNormas.vue?vue&type=script&lang=js&"
export * from "./BancoNormas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports